import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Grid } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { useNodeTemplate } from '../../../hooks';
import { RFConfigContext } from '../../../contexts';
import { DISTILLATION_COLUMN_RC_CONFIG } from './RFDistillationColumnRCNode.config';
/**
 * Component renders "distillationColumnRC" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFDistillationColumnRCNodeFC = ({ id, data, type, isConnectable = true, selected }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: DISTILLATION_COLUMN_RC_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { "data-templateid": data.templateCode, templateRows: 'auto auto', gap: '4px', children: [_jsx(RFNodeIcon, { id: id, rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: _jsx(RFSvg, { name: DISTILLATION_COLUMN_RC_CONFIG.icon, width: 190, height: 364 }) }), _jsx(Box, { children: _jsx(Box, { maxW: '204px', fontSize: '12px', lineHeight: '14px', fontWeight: 700, textAlign: 'center', className: 'cut-text', children: data.title }) })] }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFDistillationColumnRCNode = RFDistillationColumnRCNodeFC;
//# sourceMappingURL=RFDistillationColumnRCNode.js.map